import './ccf-edit-book-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfEditBookIconProps extends SvgIconProps {}

/**
 * CcfEditBookIcon used to disply edit button in the contact card address panel
 * @param props - CcfEditBookIconProps
 * @example -- <CcfEditBookIcon />
 */
export function CcfEditBookIcon(props: CcfEditBookIconProps) {
  return (
      <SvgIcon {...props}>
        <g id="Edit" clipPath="url(#clip-Edit)">
          <g id="Group_118949" data-name="Group 118949" transform="translate(-1 -1)" opacity="0.853">
            <rect id="Rectangle_37572" data-name="Rectangle 37572" width="32" height="32" transform="translate(-3 -3)" fill="gray" opacity="0"/>
            <g id="manage-forms" transform="translate(5 3.359)">
              <path id="Path_25009" data-name="Path 25009" d="M13.949,14.253c0,.408,0,1.224-.41,1.224H2.872c-.41,0-1.231-1.306-1.231-1.714V3.641c0-.408.821-.408,1.231-.408H9.026V1.6H2.872C1.231,1.6,0,2.008,0,3.641V14.253A3.074,3.074,0,0,0,2.872,17.11H13.538c1.641,0,2.051-1.224,2.051-2.857V9.763H13.949v4.49Z" transform="translate(0 -0.47)" fill="#526b7a"/>
              <path id="Path_25010" data-name="Path 25010" d="M12,10.926h2.133l7.713-8.49L19.795.64,12,8.967Z" transform="translate(-5.846)" fill="#526b7a"/>
            </g>
          </g>
        </g>
      </SvgIcon>
  );
}

export default CcfEditBookIcon;
